
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/[tag]/[slug]",
      function () {
        return require("private-next-pages/blog/[tag]/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/[tag]/[slug]"])
      });
    }
  